import { productIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const getGraphicBlanks = {
  name: "getGraphicBlanks" as const,
  input: z.object({}),
  output: z.object({
    products: z.array(
      z.object({
        productId: productIdFormat.schema,
        title: z.string(),
        sku: z.string().nullable(),
        imageUrl: z.string().nullable(),
        barcodes: z.array(z.string()),
      }),
    ),
  }),
};
